import React from 'react';

import Layout from 'components/layouts';

import { offerCategory } from 'utils/offersFormHelper';

import Form from './form'

const pageInfo = {
  name: "Create new product"
};

const NewOffer = () => {

    const searchParams = new URLSearchParams(window.location.search);
    const eventId = searchParams.get('eventId');
    const category = searchParams.get('category');

    // An event entry point defaults to a ticket, but a non-ticket category
    // creates an event-related product instead.
    const isEventProduct = !!eventId && [offerCategory.merch.value, offerCategory.perk.value].includes(category);
    const isTicket = !!eventId && !isEventProduct;

    pageInfo.name = `Create new ${isTicket ? "ticket" : "product"}`

    return (
        <Layout context='teacher'
                back={ true }
                pageInfo={ pageInfo }
                activeMenuItem={eventId ? "events" : "perks"}>

          <Form />

        </Layout>
    );
};

export default NewOffer;
